import { Editor, Node } from 'slate';
import { ReactEditor, toSlatePoint } from 'slate-react';

export function getElementsByAttribute(editor, attribute) {
    return Array.from(
        Editor.nodes(editor, {
            at: [],
            match: n => !Editor.isEditor(n) && n[attribute] === true,
        })
    );
}

export function getElementsByType(editor, type, hasText) {
    return Array.from(
        Editor.nodes(editor, {
            at: [],
            match: n => {
                if (hasText) return !Editor.isEditor(n) && n.type === type && n.children.length > 0 && n.children[0].text !== '' ? true : false
                else return !Editor.isEditor(n) && n.type === type
            },
        })
    );
}

export function checkIfItHasSuperscript(editor, index) {
    const allSuperscripts = getElementsByAttribute(editor, 'superscript');
    const hasSuperscript = allSuperscripts.find(sup => sup[1][0] === index);
    return hasSuperscript;
}

export function getNewContentPosition(arr, superscriptNumber) {
    if (arr.length === 1) return +arr[0] > superscriptNumber ? 0 : 1
    else {
        let indexA = arr.findIndex(item => +item.text + 1 === superscriptNumber);
        let indexB = arr.findIndex(item => +item.text === superscriptNumber);
        let indexC = arr.findIndex(item => +item.text - 1 === superscriptNumber);
        arr.map((item, index) => {
            if (+item.text === superscriptNumber) indexB = index;
            else if (+item.text + 1 === superscriptNumber) indexA = index;
            else if (+item.text - 1 === superscriptNumber) indexC = index;
        })
        if (indexB !== -1) return indexB
        else if (indexA !== -1) return indexA + 1
        else if (indexC !== -1) return indexC
        else return null
    }
}

export function findNodeAtHeight(editor, domElement, height) {
    // Get the DOM element for the editor

    const editorRect = domElement.getBoundingClientRect();


    // Choose an X coordinate within the editor bounds (e.g., center horizontally)
    const x = editorRect.left + editorRect.width / 2;
    const tempY = (editorRect.top > 0 ? height - editorRect.top : height + editorRect.top)
    const y = (tempY > 0 ? tempY : tempY * -1) - 80 ; // The desired vertical position (Y coordinate)
    // Use the native browser API to get the DOM range at the point
    // Note: 'document.caretRangeFromPoint' is widely supported but may need
    // a polyfill or alternative for older browsers.
    const caca = document.elementFromPoint(x, y);
    // if (caca) {
    //     const node = ReactEditor.toSlateNode(editor, caca);
    //     const path = node ? ReactEditor.findPath(editor, node) : null;
    //     return path
    // } else return null;
    return null

    //     // Convert the DOM point to a Slate Point
    //     const slatePoint = ReactEditor.toSlatePoint(editor, {
    //         node: domNode,
    //         offset: domOffset,
    //     });

    //     if (slatePoint) {
    //         // Get the corresponding Slate node using its path
    //         const [node, path] = Editor.node(editor, slatePoint.path);
    //         return { node, path, slatePoint };
    //     }
    // }

    // return null;
};


export function getNewFWposition(allBoundaries, superscriptPosition, currentBoundaryIndex, newCreatedFNW, allChildren) {
    if (allBoundaries.length > 0) {
        if (allBoundaries.length - 1 === currentBoundaryIndex) {
            const lastChildrenIndex = allChildren.length - 1;

            if (newCreatedFNW.length > 0) {
                const index = newCreatedFNW.findIndex(nc => nc.at > superscriptPosition);
                if (index !== -1) {
                    return newCreatedFNW[index].at
                } else {
                    return lastChildrenIndex
                }

            } else {
                return lastChildrenIndex
            }

        } else {
            const boundary = allBoundaries.find((b, bIndex) => {
                return b.at[0] > superscriptPosition + 1
            })

            if (boundary && newCreatedFNW.length > 0) {
                const index = newCreatedFNW.findIndex(nc => nc.at > superscriptPosition && nc.at < boundary.at[0]);
                if (index !== -1) {
                    return newCreatedFNW[index].at
                } else {
                    return boundary.at[0] - 1
                }

            } else if (boundary) {
                return boundary.at[0] - 1

            } else if (newCreatedFNW.length > 0) {
                const index = newCreatedFNW.findIndex(nc => nc.at > superscriptPosition);
                if (index !== -1) {
                    return newCreatedFNW[index].at
                }
            }
        }

    } else {
        if (newCreatedFNW.length === 1) {
            return newCreatedFNW[0]

        } else {
            return allChildren.length
        }
    }
}

export function calculateHeight(elementStyle) {
    const span = document.createElement("span");
    document.body.appendChild(span);
    span.style.font = elementStyle.fontSize + ' ' + elementStyle.fontFamily;
    span.style.lineHeight = elementStyle.lineHeight;
    span.style.position = 'absolute';
    span.style.visibility = 'hidden';
    span.textContent = "m";
    const height = span.clientHeight;
    const marginBottom = elementStyle.marginBottom ? +elementStyle.marginBottom.split('p')[0] : 0
    const marginTop = elementStyle.marginTop ? +elementStyle.marginTop.split('p')[0] : 0
    document.body.removeChild(span);
    return height + this.ptsToPxls(marginBottom) + this.ptsToPxls(marginTop);
}

export function getTextWidth(text, style, other) {
    const span = document.createElement("span");
    document.body.appendChild(span);
    span.style.font = style.fontSize + ' ' + style.fontFamily;
    span.style.lineHeight = style.lineHeight;
    span.style.position = 'absolute';
    span.style.visibility = 'hidden';
    if (other) span.style[other.key] = other.value;
    span.textContent = text;
    const width = span.clientWidth;
    document.body.removeChild(span);
    return width;
}